import { BRAND, SERVICES, SERVICE_AREAS } from "@/data/site";

export const orgSchema = () => ({
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  "@id": `${BRAND.website}/#organization`,
  name: BRAND.name,
  url: BRAND.website,
  telephone: BRAND.phone,
  email: BRAND.email,
  image: `${BRAND.website}/og-image.jpg`,
  priceRange: "$$$",
  address: {
    "@type": "PostalAddress",
    addressLocality: BRAND.address.city,
    addressRegion: BRAND.address.region,
    postalCode: BRAND.address.postalCode,
    addressCountry: BRAND.address.country,
  },
  geo: { "@type": "GeoCoordinates", latitude: BRAND.geo.lat, longitude: BRAND.geo.lng },
  openingHoursSpecification: BRAND.hoursSchema.map((h) => ({
    "@type": "OpeningHoursSpecification",
    dayOfWeek: h.dayOfWeek,
    opens: h.opens,
    closes: h.closes,
  })),
  sameAs: [BRAND.social.instagram, BRAND.social.facebook],
  areaServed: SERVICE_AREAS.map((a) => ({ "@type": "City", name: `${a.name}, ${a.state}` })),
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Flooring Services",
    itemListElement: SERVICES.map((s) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name: s.name },
    })),
  },
});

export const breadcrumbSchema = (items: { name: string; url: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.url,
  })),
});

export const faqSchema = (faqs: { q: string; a: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const serviceSchema = (
  name: string,
  description: string,
  url: string,
  areaServed?: string[],
) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  description,
  url,
  provider: { "@id": `${BRAND.website}/#organization` },
  areaServed: areaServed && areaServed.length > 0
    ? areaServed.map((a) => ({ "@type": "City", name: a }))
    : SERVICE_AREAS.map((a) => ({ "@type": "City", name: `${a.name}, ${a.state}` })),
});

export const articleSchema = (p: { title: string; description: string; date: string; url: string; image?: string }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: p.title,
  description: p.description,
  datePublished: p.date,
  author: { "@type": "Organization", name: BRAND.name },
  publisher: { "@type": "Organization", name: BRAND.name, logo: { "@type": "ImageObject", url: `${BRAND.website}/favicon.ico` } },
  mainEntityOfPage: p.url,
  ...(p.image ? { image: p.image } : {}),
});
